var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat_arrow_left_icon",
    transform: "translate(-670 -238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2424",
    "data-name": "\\uD328\\uC2A4 2424",
    d: "M-20621.482-11102.708l-6.4,6.4,6.4,6.4",
    transform: "translate(21304 11343)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_17386",
    "data-name": "\\uC0AC\\uAC01\\uD615 17386",
    width: 18,
    height: 18,
    transform: "translate(670 238)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrrowLeft);
export default __webpack_public_path__ + "static/media/arrrow-left.566f273bbc1ddb9b4ffc320772fcbb7f.svg";
export { ForwardRef as ReactComponent };